import React, { FC, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Button, Table, TableBody, TableCell, TableRow, TableHead, Checkbox, IconButton, TableContainer, Select, InputLabel, MenuItem, Menu } from '@material-ui/core'
import { Edit, Delete, Add, Close } from '@material-ui/icons'
import useStore, { budgetStore, snackBar } from 'store'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import * as XLSX from 'xlsx'
import { userIsSuperAdmin } from 'utils/roles'
import Import from 'assets/icons/Import.svg'
import Search from 'assets/icons/Search.svg'
import Export from 'assets/icons/Export.svg'
import DeleteIcon from 'assets/icons/ims/Delete.svg'
import Users from 'assets/icons/Users.svg'
import MemberIcon from 'assets/icons/MemberIcon.svg'
import UserIcon2 from 'assets/icons/UserIcon2.svg'
import EditIcon2 from 'assets/icons/ims/Edit2.svg'
import FilterIcon from 'assets/icons/ims/Filter.svg'
import ZeroFilter from 'assets/icons/ims/ZeroFilter.svg'
import { TextField } from '@material-ui/core'
import UserNewModal from './UserNewModal'
import RemoveContactModal from './RemoveContactModal'
import ImportUsersModal, { UPDATE_COLUMN_MAP } from './ImportUsersModal'
import {
  fetchUserFamily,
  getFamilyRelations,
  fetchTags,
  fetchUser,
  fetchTagTypes,
  getOneHousehold,
  getAssignTags,
  removeUser,
  User
} from './usersApi'
import { buildUserFormData } from './buildUserFormData'
import { emptySaveScratch, SaveScratch } from './saveUserAction'


const TableHeadStyled = styled(TableHead)`
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.95);
`
const Wrap = styled.div`
  background-color:${theme.color.dialogBackground};
  @media (max-width: 768px) {
    background: rgba(0,0,0,0.05);
    padding: 1rem;
  }
  flex:1;
  padding: 1rem;
  overflow:auto;
`
const Container = styled.div`
  display: flex;
  height: 151.563px;
  flex-direction: column;
  align-items: flex-end;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const ContactsTable = styled.div`
  margin-top: 20px;
  display: flex;
  flex: 1; 
  min-height: 0;
  padding: 0.909px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const Header = styled.div`
  display: flex;
  height: 85.781px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`
const HLeftItem = styled.div`
  display: flex;  
  height: 85.781px;
  align-items: center;
  /*gap: 11.989px;*/
`
const HRightItem = styled.div`
  display: flex;
  height: 67.997px;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`
const HRItemContainer = styled.div`
  display: flex;
  height: 67.997px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7.997px;
`
const HRHeading1 = styled.div`
  display: flex;  
  padding-right: 0.506px;
  justify-content: center;
  align-items: center;
  color: #0F172A;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px; 
`
const HRHeading2 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; 
`
const StyledMemberIcon = styled(Image)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`
const TableStyled = styled(Table)`
` 
const HLeftItemContainer1 = styled.div`
  display: flex;
  height: 85.781px;
  align-items: center;
  gap: 11.989px;
`
const HLeftItemInnerContainer1 = styled.div`
  display: flex;
  height: 85.781px;
  padding: 12.898px 20.909px 0.909px 20.909px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const HLeftItemInnerContainer1Content = styled.div`
  display: flex;
  height: 59.986px;
  align-items: center;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const HLeftItemInnerContainer2 = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`
const HLeftItemInnerIconContainer1 = styled.div`
  display: flex;
  width: 35.994px;
  height: 35.994px;
  padding: 7.997px 7.997px 0 7.997px;
  flex-direction: column;  
  align-items: flex-start;
  border-radius: 30504000px;
  background: rgba(37, 99, 235, 0.10);
`
const HLeftItemInnerTextContainer1 = styled.div`
display: flex;
height: 59.986px;
flex-direction: column;
align-items: flex-start;
`
const StyledUserIcon2 = styled(Image)`
  height: 20px; 
  flex-shrink: 0;
  align-self: stretch;
`
const HLeftItemInnerText1Container1 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const HLeftItemInnerText2Container1 = styled.div`
  color: #0F172A;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const HLeftItemInnerText3Container1 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`
const ActionsImage = styled(Image)`
  width: 16px;
  height: 16px;
`
const ActionsImage2 = styled(Image)`
  width: 16px;
  height: 16px;
  color: white;
`
const AddButton = styled(Button)`
  min-width: 200px;
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #2563EB;
  color: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
const StyledIconButton = styled(IconButton)`
  && {
    padding: 7px;
    border-radius: 8px;
    border: 1px solid #E2E8F0;
    background: #FFF;
  }
  &&:hover {
    border-color: #CBD5E1;
    background: #F1F5F9;
  }
`
const ImportButton = styled(Button)`
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 0.909px solid #E2E8F0;
  color: white;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  background: #00A63E;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const ImportExportImage = styled(Image)`
  width: 16px;
  height: 16px;
`
const SampleButton = styled(Button)`
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 0.909px solid #E2E8F0;
  color: #FFF;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  background: #475569;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const SearchBar = styled.div`
  display: flex;
  width: 100%;
  height: 49.787px;
  padding: 15px 0px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`
const SearchInput = styled(TextField)`
  width: 100%;
  border-radius: 8px;
  display: flex;
  background: none;
  align-items: center;
  border: none;
  gap: 10px;
  background: #FFF;
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0px;
  }
`
const FilterButton = styled(Button)<{ active?: boolean }>`
  display: flex;
  padding: 22px 24px;
  height: 50px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 0.909px solid ${p => p.active ? '#8EC5FF' : '#D1D5DC'};
  color: ${p => p.active ? '#1447E6' : '#000000'};
  background: ${p => p.active ? '#EFF6FF' : '#FFF'};
`
const FilterImageIcon = styled.div<{ active?: boolean; src: string }>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  background-color: ${p => p.active ? '#1447E6' : '#364153'};
  -webkit-mask-image: url(${p => p.src});
  mask-image: url(${p => p.src});
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
`
const FilterContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 15px;
  padding: 16px 15.994px 16px 15.994px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15.994px;
  border-radius: 8px;
  border: 0.909px solid #E5E7EB;
  background: #F9FAFB;
`
const FilterTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #364153;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const FilterTitleRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`
const FilterModeToggle = styled.div`
  display: flex;
  align-items: center;
  border-radius: 6px;
  border: 0.909px solid #D1D5DC;
  overflow: hidden;
`
const FilterModeButton = styled(Button)<{ selected: boolean }>`
  display: flex;
  padding: 4px 12px;
  min-width: 0;
  border-radius: 0;
  color: ${p => p.selected ? '#FFF' : '#364153'};
  background: ${p => p.selected ? '#1447E6' : '#FFF'};
  text-align: center;
  font-family: Rubik;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-transform: none;
  &:hover {
    background: ${p => p.selected ? '#1447E6' : '#F1F5F9'};
  }
`
const FilterSectionContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
  gap: 7.997px;
`
const FilterSectionLabel = styled.div`
  width: 100%;
  color: #6A7282;
  text-align: right;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display: flex;

`
const FilterChipList = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  align-self: stretch;
`
const FilterChipButton = styled(Button)<{ selected: boolean; tagcolor: string; tagborder: string; tagbg: string; roleradius?: boolean }>`
  display: flex;
  padding: 5px 12px;
  align-items: center;
  gap: 4px;
  border-radius: ${p => p.roleradius ? '6px' : '30504000px'};
  border: 0.909px solid ${p => p.selected ? p.tagcolor : p.tagborder};
  background: ${p => p.selected ? p.tagcolor : p.tagbg};
  color: ${p => p.selected ? '#FFF' : p.tagcolor};
  text-align: center;
  font-family: Rubik;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-transform: none;
`
const FilterResetTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #364153;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const TableContainerStyled = styled(TableContainer)`
  height: calc(100vh - 300px);
`
const TableCellRight = styled(TableCell)`
  body[dir="rtl"] &.MuiTableCell-root {
    text-align: right;
  }
`
// Phone numbers must stay on one line; reserve enough width for a long
// (international, ~20-char) number so it never wraps.
const PhoneCell = styled(TableCellRight)`
  &.MuiTableCell-root {
    white-space: nowrap;
    min-width: 170px;
  }
`
const TagChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`
const StatusTagChip = styled.div`
  display: flex;
  padding: 3px 10px;
  align-items: center;
  border-radius: 30504000px;
  border: 0.909px solid rgba(37, 99, 235, 0.25);
  background: rgba(37, 99, 235, 0.06);
  color: #2563EB;
  text-align: center;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`
const RoleTagChip = styled.div`
  display: flex;
  padding: 3px 10px;
  align-items: center;
  border-radius: 6px;
  border: 0.909px solid rgba(37, 99, 235, 0.25);
  background: rgba(37, 99, 235, 0.06);
  color: #432DD7;
  text-align: center;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`
const OtherTagChip = styled.div<{ tagcolor: string; tagborder: string }>`
  display: flex;
  padding: 3px 10px;
  align-items: center;
  border-radius: 30504000px;
  border: 0.909px solid ${p => p.tagborder}40;
  background: ${p => p.tagcolor}10;
  color: ${p => p.tagcolor};
  text-align: center;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`
const BulkActionsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: #EFF6FF;
  border-bottom: 1px solid #BFDBFE;
`
const BulkActionsText = styled.div`
  color: #1D4ED8;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
`
const BulkActionsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`
const SelectFirst50Link = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #2563EB;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
  &:hover { color: #1D4ED8; }
`
const BulkDeleteButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  margin-right: 10px;
  border-radius: 6px;
  border: 1px solid #DC2626;
  background: #FFF;
  color: #DC2626;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 500;
  min-width: 0;
`
const BulkProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #E2E8F0;
`
const BulkProgressBar = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #E2E8F0;
  overflow: hidden;
`
const BulkProgressFill = styled.div<{ pct: number }>`
  height: 100%;
  border-radius: 999px;
  background: #2563EB;
  width: ${p => p.pct}%;
  transition: width 0.2s ease;
`
const BulkProgressLabel = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 13px;
`

const BULK_DELETE_LIMIT = 50

const TAG_COLORS = [
  { color: '#EA580C', border: '#EA580C' },
  { color: '#0284C7', border: '#0284C7' },
  { color: '#16A34A', border: '#16A34A' },
  { color: '#9333EA', border: '#9333EA' },
  { color: '#DC2626', border: '#DC2626' },
  { color: '#0891B2', border: '#0891B2' },
  { color: '#CA8A04', border: '#CA8A04' },
  { color: '#BE185D', border: '#BE185D' },
]

const getTagColor = (name: string) => {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length]
}

const ROLE_TAG_STYLE = { color: '#432DD7', border: 'rgba(37, 99, 235, 0.25)', bg: 'rgba(37, 99, 235, 0.06)' }
const STATUS_TAG_STYLE = { color: '#2563EB', border: 'rgba(37, 99, 235, 0.25)', bg: 'rgba(37, 99, 235, 0.06)' }

const PopulationManagement: FC = () => {
  const { t } = useTranslation(['population', 'budget'])
  const { imsUsersStore, user: userStore, orgs: orgStore, modulesStore } = useStore()
  const [openNewUserModal, setNewUserModal] = useState(false)
  const [openRemoveContactModal, setRemoveContactModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [disableEdit, setDisableEdit] = useState(false)
  const [search, setSearch] = useState('')
  const [removeUserId, setRemoveUserId] = useState(0)
  const [removeUserName, setRemoveUserName] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)
  const [loadingUserId, setLoadingUserId] = useState<number | null>(null)
  const [openImportModal, setOpenImportModal] = useState(false)
  const [sampleMenuAnchor, setSampleMenuAnchor] = useState<HTMLElement | null>(null)
  const [selectedUserIds, setSelectedUserIds] = useState<Set<number>>(new Set())
  const [bulkDeleting, setBulkDeleting] = useState(false)
  const [bulkProgress, setBulkProgress] = useState({ deleted: 0, total: 0 })
  const [exporting, setExporting] = useState(false)
  const [exportingKind, setExportingKind] = useState<null | 'update' | 'group'>(null)
  const [exportProgress, setExportProgress] = useState({ done: 0, total: 0 })

  // Tagged with the contact it was read from, so saveFullUser can tell whether
  // it belongs to the contact being saved.
  const [saveScratch, setSaveScratch] = useState<SaveScratch>(emptySaveScratch)

  // Bumped when an import may have created tags, so the contact form re-reads
  // the tag lists instead of offering the set it cached before the import.
  const [tagListsVersion, setTagListsVersion] = useState(0)

  const [filterActive, setFilterActive] = useState(false)
  const [filterMode, setFilterMode] = useState<'OR' | 'AND'>('OR')
  const [selectedRoleTags, setSelectedRoleTags] = useState<Set<string>>(new Set())
  const [selectedOtherTags, setSelectedOtherTags] = useState<Set<string>>(new Set())
  const [selectedStatusTags, setSelectedStatusTags] = useState<Set<string>>(new Set())

  const toggleFilterTag = (setter: React.Dispatch<React.SetStateAction<Set<string>>>, tagName: string) => {
    setter(prev => {
      const next = new Set(prev)
      if (next.has(tagName)) next.delete(tagName)
      else next.add(tagName)
      return next
    })
  }

  const resetFilters = () => {
    setSelectedRoleTags(new Set())
    setSelectedOtherTags(new Set())
    setSelectedStatusTags(new Set())
    setFilterMode('OR')
  }

  const activeFilterCount = selectedRoleTags.size + selectedOtherTags.size + selectedStatusTags.size

  const ConfirmContactRemoveAction = (userId, userName) => {
    setRemoveContactModal(true)
    setRemoveUserId(userId)
    setRemoveUserName(userName)
  }

  const toggleUser = (userId: number) => {
    setSelectedUserIds(prev => {
      const next = new Set(prev)
      if (next.has(userId)) {
        next.delete(userId)
      } else if (next.size < BULK_DELETE_LIMIT) {
        next.add(userId)
      }
      return next
    })
  }

  const selectFirst50 = () => {
    setSelectedUserIds(new Set(filteredUsers.slice(0, BULK_DELETE_LIMIT).map(u => u.userId)))
  }

  const downloadSampleFile = (data: any[][], fileName: string) => {
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet(data)
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    XLSX.writeFile(wb, fileName)
  }

  const downloadCreateSample = () => {
    setSampleMenuAnchor(null)
    downloadSampleFile([
      [
        'First Name', 'Last Name', 'Maiden Name', 'Nickname', 'Date of Birth', 'ID Number',
        'Gender', 'Marital Status', 'Mobile Phone', 'Extra Mobile number', 'Phone number', 'Email',
        'City', 'Street', 'House Number', 'Shelter', 'Emergency Contact 1 name', 'Emergency Contact 1 Phone',
        'Emergency Contact 2 name', 'Emergency Contact 2 Phone', 'Tags', 'Roles', 'User Type', 'Is Mekome member'
      ],
      [
        'שם פרטי*', 'שם משפחה*', 'שם אמצעי', 'כינוי', 'תאריך לידה', 'תעודת זהות*',
        'מין', 'מצב משפחתי', 'טלפון נייד*', 'נייד נוסף', 'טלפון נוסף', 'דואר אלקטרוני*',
        'ישוב', 'רחוב', 'מספר בית', 'ממ”ד/מקלט', 'איש קשר במקרה אסון', 'טלפון איש קשר במקרה אסון',
        'איש קשר 2 במקרה אסון', 'טלפון איש קשר 2 במקרה אסון', 'תגיות', 'תפקידים', 'סוג משתמש', 'חבר מקומי הודעות'
      ],
      ['ישראל', 'ישראלי', '', 'ישי', '01/01/1985', '123456789', 'זכר', 'נשוי', '+972501234567', '+972501234567', '04-6954802', 'israel@example.com', 'תל אביב', 'הרצל', '5', 'D-16', 'שרה ישראלי', '+972501234568', '', '', 'תושב#גימלאים', 'מנהל קהילה#תושב', 'קבוצה א#קבוצה ב', 'כן'],
      ['שרה', 'כהן', '', '', '15/06/1992', '987654321', 'נקבה', 'רווקה', '+972509876543', '+972509876543', '', 'sarah@example.com', 'ירושלים', 'יפו', '12', 'D-17', '', '', '', '', '', '', '', 'לא'],
    ], 'import_sample_new_users.xlsx')
  }

  const downloadUpdateSample = () => {
    setSampleMenuAnchor(null)
    downloadSampleFile([
      [
        'First Name', 'Last Name', 'Maiden Name', 'Nickname', 'Date of Birth', 'ID Number',
        'Gender', 'Marital Status', 'Phone number', 'City', 'Street', 'House Number', 'Shelter',
        'Emergency Contact 1 name', 'Emergency Contact 1 Phone', 'Emergency Contact 2 name',
        'Emergency Contact 2 Phone', 'Tags', 'Roles', 'User Type', 'Is Mekome member'
      ],
      [
        'שם פרטי*', 'שם משפחה*', 'שם אמצעי', 'כינוי', 'תאריך לידה', 'תעודת זהות*',
        'מין', 'מצב משפחתי', 'טלפון נוסף', 'ישוב', 'רחוב', 'מספר בית', 'ממ”ד/מקלט',
        'איש קשר במקרה אסון', 'טלפון איש קשר במקרה אסון', 'איש קשר 2 במקרה אסון',
        'טלפון איש קשר 2 במקרה אסון', 'תגיות', 'תפקידים', 'סוג משתמש', 'חבר מקומי הודעות'
      ],
      ['ישראל', 'ישראלי', '', 'ישי', '01/01/1985', '123456789', 'זכר', 'נשוי', '04-6954802', 'מחניים', 'הרצל', '5', 'D-16', 'שרה ישראלי', '+972501234568', '', '', 'תושב#גימלאים', 'מנהל קהילה#תושב', 'קבוצה א#קבוצה ב', 'כן'],
      ['שרה', 'כהן', '', '', '15/06/1992', '987654321', 'נקבה', 'רווקה', '', 'מחניים', 'יפו', '12', 'D-17', '', '', '', '', '', '', '', 'לא'],
    ], 'update_sample_existing_users.xlsx')
  }

  const downloadChildSample = () => {
    setSampleMenuAnchor(null)
    downloadSampleFile([
      ['Parent ID', 'Child ID', 'Child First Name', 'Child Last Name', 'Child Middle Name', 'Child Mobile', 'Child Date of Birth', 'Child Gender'],
      ['תעודת זהות הורה*', 'תעודת זהות ילד*', 'שם פרטי ילד*', 'שם משפחה ילד*', 'שם אמצעי ילד', 'נייד ילד', 'תאריך לידה ילד', 'מגדר ילד'],
      ['123456789', '23123223', 'שאול', 'סיני', 'חן', '+972507955877', '10/05/2003', 'זכר'],
      ['987654321', '987654321', 'דוד', 'אזולאי', '', '', '', ''],
    ], 'update_sample_children.xlsx')
  }

  const formatBirthDateForExport = (iso?: string | null): string => {
    if (!iso) return ''
    const d = new Date(iso)
    if (isNaN(d.getTime())) return ''
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${pad(d.getUTCDate())}/${pad(d.getUTCMonth() + 1)}/${d.getUTCFullYear()}`
  }

  const EXPORT_FIELD_GETTERS: Record<string, (form: any) => string> = {
    givenName: form => form.population.firstName || '',
    familyName: form => form.population.lastName || '',
    middleName: form => form.population.middleName || '',
    nickName: form => form.population.nickName || '',
    dateOfBirth: form => formatBirthDateForExport(form.population.birthDate),
    israeliId: form => form.population.identityNumber || '',
    gender: form => form.population.gender || '',
    maritalStatus: form => form.population.maritalStatus || '',
    otherPhone: form => form.population.extraPhone || '',
    addressCity: form => form.population.city || '',
    addressStreet: form => form.population.street || '',
    addressHouseNumber: form => form.population.houseNumber || '',
    shelter: form => form.population.shelter || '',
    contactPerson1: form => form.emergency.contacts[0]?.name || '',
    contactPersonCellPhone1: form => form.emergency.contacts[0]?.phone || '',
    contactPerson2: form => form.emergency.contacts[1]?.name || '',
    contactPersonCellPhone2: form => form.emergency.contacts[1]?.phone || '',
    tagsOthers: form => (form.contacts.tags || []).map((t: any) => t.tagName).join('#'),
    tagsRoles: form => (form.contacts.roles || []).map((t: any) => t.tagName).join('#'),
    tagsStatus: form => (form.population.userTypes || []).map((t: any) => t.tagName).join('#'),
    isLocalMember: form => form.population.isLocalMember ? 'כן' : 'לא',
  }

  // Max users processed in parallel for export / bulk-delete, to bound the
  // number of concurrent requests while avoiding the previous serial N+1.
  const EXPORT_CONCURRENCY = 8

  const getUserExportData = async (id: number) => {
    // The four reads are independent — fetch them in parallel, not serially.
    const [user, profile, family, tags] = await Promise.all([
      fetchUser(id, orgStore.currentOrgId),
      getOneHousehold(id, orgStore.currentOrgId),
      getFamilyRelations(id, orgStore.currentOrgId),
      getAssignTags(id, orgStore.currentOrgId),
    ])
    return buildUserFormData(user.data, family, tags, profile?.houseHold)
  }

  const handleExportUsers = async () => {
    const users = filteredUsers
    if (users.length === 0) return

    setExporting(true)
    setExportingKind('update')
    setExportProgress({ done: 0, total: users.length })

    try {
      const headers = Object.keys(UPDATE_COLUMN_MAP)
      const fields = Object.values(UPDATE_COLUMN_MAP)
      const rows: string[][] = []

      for (let start = 0; start < users.length; start += EXPORT_CONCURRENCY) {
        const chunk = users.slice(start, start + EXPORT_CONCURRENCY)
        const forms = await Promise.all(chunk.map(u => getUserExportData(u.userId)))
        for (const form of forms) {
          rows.push(fields.map(field => EXPORT_FIELD_GETTERS[field]?.(form) ?? ''))
        }
        // Once per chunk rather than once per row: a per-row setState re-renders
        // this whole page, and an export of a few thousand users did that a few
        // thousand times. The bar now moves in steps the size of a chunk.
        setExportProgress(prev => ({ ...prev, done: prev.done + forms.length }))
      }

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])
      wb.Workbook = { Views: [{ RTL: true }] }
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, `ייצוא-משתמשים-${new Date().toISOString().slice(0, 10)}.xlsx`)
    } catch (e) {
      snackBar.showError(t`export_error`)
    } finally {
      setExporting(false)
      setExportingKind(null)
    }
  }

  // Export in the exact structure the "add members to a group from file" flow
  // reads: the first three rows are ignored (title / note / headers) and data
  // starts on the fourth row, with columns fixed at
  // firstName | lastName | nick | israeliID | phone1 | phone2 | email.
  const handleExportUsersForGroup = async () => {
    const users = selectedUserIds.size > 0
      ? filteredUsers.filter(u => selectedUserIds.has(u.userId))
      : filteredUsers
    if (users.length === 0) return

    setExporting(true)
    setExportingKind('group')
    setExportProgress({ done: 0, total: users.length })

    try {
      const rows: string[][] = []
      for (let start = 0; start < users.length; start += EXPORT_CONCURRENCY) {
        const chunk = users.slice(start, start + EXPORT_CONCURRENCY)
        const results = await Promise.all(chunk.map(async u => ({ u, form: await getUserExportData(u.userId) })))
        for (const { u, form } of results) {
          rows.push([
            form.population.firstName || '',
            form.population.lastName || '',
            form.population.nickName || '',
            form.population.identityNumber || u.israelId || '',
            u.mainMobilePhone || '',
            form.population.extraPhone || '',
            u.email || '',
          ])
        }
        setExportProgress(prev => ({ ...prev, done: prev.done + results.length }))
      }

      const headers = ['שם פרטי', 'שם משפחה', 'כינוי', 'מספר תעודת זהות', 'טלפון נייד 1', 'טלפון נייד 2', 'דוא"ל']
      const aoa = [
        ['הוספת חברים לקבוצה מקובץ'],
        ['שלוש השורות הראשונות אינן נטענות (כותרות). הנתונים מתחילים מהשורה הרביעית.'],
        headers,
        ...rows,
      ]
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet(aoa)
      wb.Workbook = { Views: [{ RTL: true }] }
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, `טעינה-לקבוצה-${new Date().toISOString().slice(0, 10)}.xlsx`)
    } catch (e) {
      snackBar.showError(t`export_error`)
    } finally {
      setExporting(false)
      setExportingKind(null)
    }
  }

  const handleBulkDelete = async () => {
    const ids = Array.from(selectedUserIds)
    setBulkDeleting(true)
    setBulkProgress({ deleted: 0, total: ids.length })
    try {
      for (let start = 0; start < ids.length; start += EXPORT_CONCURRENCY) {
        const chunk = ids.slice(start, start + EXPORT_CONCURRENCY)
        await Promise.all(chunk.map(async id => {
          await removeUser(id, orgStore.currentOrgId)
          imsUsersStore.removeUser(id)
        }))
        setBulkProgress(prev => ({ ...prev, deleted: prev.deleted + chunk.length }))
      }
    } catch (e) {
      snackBar.showError(t`delete_error`)
      // Part of the chunk may have been deleted before the failure, so here the
      // list really does have to be re-read. On the success path it does not:
      // each row is already removed from the store as its delete returns, and
      // re-fetching the whole list just to arrive at the same rows was undoing
      // that work.
      loadUsers()
    } finally {
      setBulkDeleting(false)
      setSelectedUserIds(new Set())
    }
  }

  const loadUsers = () => {
    // Only managers (director/operator in the current community) or super admin
    // may read the community user list — the basicinfo endpoint returns 403
    // otherwise. Gate the call so it never fires for unauthorized users (e.g.
    // via direct URL navigation to the population-management page).
    if (!modulesStore.showPopulationFeature()) return
    setLoading(true)
    imsUsersStore.load(orgStore.currentOrgId)
      .catch(() => snackBar.showError(t`list_load_error`))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    loadUsers()
  }, [orgStore.currentOrgId])

  const parseTags = (tags: any) => {
    if (Array.isArray(tags)) return tags
    if (typeof tags === 'string') {
      try {
        const parsed = JSON.parse(tags)
        return Array.isArray(parsed) ? parsed : []
      } catch {
        return []
      }
    }
    return []
  }

  const getTagNamesByType = (user: any, typeName: string) => {
    return parseTags(user?.tags)
      .filter(t => t?.TypeName === typeName)
      .map(t => t.Tag)
  }

  const tagOptions = useMemo(() => {
    const roles = new Set<string>()
    const others = new Set<string>()
    const statuses = new Set<string>()
    ;(imsUsersStore.allUsers as any[]).forEach(u => {
      parseTags(u?.tags).forEach(t => {
        if (!t?.Tag) return
        if (t.TypeName === 'role') roles.add(t.Tag)
        else if (t.TypeName === 'others') others.add(t.Tag)
        else if (t.TypeName === 'status') statuses.add(t.Tag)
      })
    })
    return { roles: Array.from(roles), others: Array.from(others), statuses: Array.from(statuses) }
  }, [imsUsersStore.allUsers])

  const filteredUsers = useMemo(() => {
    let users = imsUsersStore.allUsers as any[]

    if (search.trim()) {
      const s = search.trim().toLowerCase()
      users = users.filter(u =>
        u.fullName?.toLowerCase().includes(s) ||
        u.nickname?.toLowerCase().includes(s) ||
        u.israelId?.toLowerCase().includes(s) ||
        u.mainMobilePhone?.toLowerCase().includes(s) ||
        u.mainMobilePhone?.replace(/^\+972(\d{2})(\d{7})/, '0$1-$2').toLowerCase().includes(s) ||
        u.mainMobilePhone?.replace(/^\+972(\d+)/, '0$1').toLowerCase().includes(s) ||
        u.email?.toLowerCase().includes(s)
      )
    }

    const matchesSelection = (userTags: string[], selected: Set<string>) =>
      filterMode === 'AND'
        ? Array.from(selected).every(tag => userTags.includes(tag))
        : userTags.some(tag => selected.has(tag))

    if (selectedRoleTags.size > 0) {
      users = users.filter(u => matchesSelection(getTagNamesByType(u, 'role'), selectedRoleTags))
    }
    if (selectedOtherTags.size > 0) {
      users = users.filter(u => matchesSelection(getTagNamesByType(u, 'others'), selectedOtherTags))
    }
    if (selectedStatusTags.size > 0) {
      users = users.filter(u => matchesSelection(getTagNamesByType(u, 'status'), selectedStatusTags))
    }

    return users
  }, [search, imsUsersStore.allUsers, selectedRoleTags, selectedOtherTags, selectedStatusTags, filterMode])

  // The four reads are independent, so opening a contact costs one round trip
  // rather than four. getUserExportData above already does this; the row-click
  // and edit-icon paths were still awaiting them one after another.
  const loadUserRecord = async (id: number) => {
    const [user, profile, family, tags] = await Promise.all([
      fetchUser(id, orgStore.currentOrgId),
      getOneHousehold(id, orgStore.currentOrgId),
      getFamilyRelations(id, orgStore.currentOrgId),
      getAssignTags(id, orgStore.currentOrgId),
    ])
    return { user, profile, family, tags }
  }

  // Only the edit path has rows to clear. Every other way into the form resets
  // this, and saveFullUser independently ignores a set that does not belong to
  // the contact it is writing - the reset keeps the state honest, the contact
  // id is what makes a leftover set harmless.
  const resetSaveScratchState = () => {
    setSaveScratch(emptySaveScratch())
  }

  const getUser = async (id: number) => {
    setLoadingUserId(id)
    try {
      const { user, profile, family, tags } = await loadUserRecord(id)

      // The contact goes in before the dialog opens, so it never paints with
      // the previously loaded one.
      resetSaveScratchState()
      setUser(user.data, family, tags, profile?.houseHold)
      setDisableEdit(true)
      setNewUserModal(true)
    } catch (e) {
      snackBar.showError(t`user_load_error`)
    } finally {
      setLoadingUserId(null)
    }
  }

  const addUser =  async () => {
    resetSaveScratchState()
    setUser(null, null, null, null)
    setDisableEdit(false)
    setNewUserModal(!openNewUserModal)
  }

  const editUser = async (id: number) => {
    setLoadingUserId(id)
    let user, profile, family, tags
    try {
      ;({ user, profile, family, tags } = await loadUserRecord(id))
    } catch (e) {
      snackBar.showError(t`user_load_error`)
      return
    } finally {
      setLoadingUserId(null)
    }

    let familyRelationIds: number[] = []

    if (Array.isArray(family.relations)) {
      // Collect the relation records that the save flow re-creates so they get
      // cleared first. Spouse (relationTypeId 3) is bidirectional and may be
      // stored in either direction, so it must be included even when the current
      // user is the relatedUserId — otherwise re-adding the spouse on save hits
      // "Bidirectional relation already exists". Parent links (type 2 where the
      // user is the child, i.e. relatedUserId === id) are intentionally left out
      // since the form never re-adds them.
      familyRelationIds = family.relations
        .filter(r => r.relationTypeId === 3 || (id && r.relatedUserId !== id))
        .map(item => item.id)
    }

    setSaveScratch({
      contactId: id,
      familyRelationIds,
      tagRelations: tags.map(item => {
        return {
          tag: item.tag,
          tagTypeId: item.tagTypeId
        }
      }),
    })

    setUser(user.data, family, tags, profile?.houseHold)
    setDisableEdit(false)
    setNewUserModal(true)
  }

  const setUser = (user: any, family: any, tags: any, household: any) => {
    setSelectedUser(buildUserFormData(user, family, tags, household))
  }

  return (
    <Wrap>
        <UserNewModal
          disableEdit={disableEdit}
          saveScratch={saveScratch}
          tagListsVersion={tagListsVersion}
          open={openNewUserModal}
          onCloseModal={setNewUserModal}
          user={selectedUser}
          onSaved={() => loadUsers()}
        />
        <ImportUsersModal
          open={openImportModal}
          onClose={() => setOpenImportModal(false)}
          communityId={orgStore.currentOrgId}
          onImported={() => {
            setTagListsVersion(v => v + 1)
            loadUsers()
          }}
        />
        <RemoveContactModal
          open={openRemoveContactModal}
          closeModal={setRemoveContactModal}
          userId={removeUserId}
          userName={removeUserName}
          onDeleted={id => {
            // onDeleted only runs once the delete has returned, so dropping the
            // row locally is enough — no full list re-fetch needed.
            imsUsersStore.removeUser(id)
          }}
        />
        <Container>
          <Header>
            <HRightItem>
              <HRItemContainer>
                <HRHeading1>
                  <Image src={Users} />
                  {t('page_title', { community: orgStore.currentOrg.name })} 
                </HRHeading1> 
                <HRHeading2>
                  {t('contacts_count', { count: filteredUsers.length })}
                </HRHeading2> 
              </HRItemContainer> 
            </HRightItem>

            <HLeftItem>
              <HLeftItemContainer1>
                 <HLeftItemInnerContainer2>
                  {userIsSuperAdmin() && (
                    <ImportButton
                      onClick={handleExportUsers}
                      disabled={exporting || filteredUsers.length === 0}
                      startIcon={exportingKind === 'update' ? <Spinner size={16} /> : <ImportExportImage src={Export}/>}
                    >
                      {t`export_for_update`}
                    </ImportButton>
                  )}
                  {userIsSuperAdmin() && (
                    <ImportButton
                      onClick={handleExportUsersForGroup}
                      disabled={exporting || filteredUsers.length === 0}
                      startIcon={exportingKind === 'group' ? <Spinner size={16} /> : <ImportExportImage src={Export}/>}
                    >
                      {t`export_for_group`}
                    </ImportButton>
                  )}
                  {userIsSuperAdmin() && (
                    <SampleButton onClick={() => setOpenImportModal(true)} startIcon={<ImportExportImage src={Import}/>}>{t`import`}</SampleButton>
                  )}
                  {userIsSuperAdmin() && (
                    <>
                      <SampleButton onClick={e => setSampleMenuAnchor(e.currentTarget)} startIcon={<ImportExportImage src={Export}/>}>{t`download_sample`}</SampleButton>
                      <Menu anchorEl={sampleMenuAnchor} open={!!sampleMenuAnchor} onClose={() => setSampleMenuAnchor(null)}>
                        <MenuItem onClick={downloadCreateSample}>{t`sample_create`}</MenuItem>
                        <MenuItem onClick={downloadUpdateSample}>{t`sample_update`}</MenuItem>
                        <MenuItem onClick={downloadChildSample}>{t`sample_children`}</MenuItem>
                      </Menu>
                    </>
                  )}
                </HLeftItemInnerContainer2>

                <HLeftItemInnerContainer1>
                  <HLeftItemInnerContainer1Content>
                    <HLeftItemInnerIconContainer1>
                      <StyledUserIcon2 src={UserIcon2} />
                    </HLeftItemInnerIconContainer1>
                    <HLeftItemInnerTextContainer1>
                      <HLeftItemInnerText1Container1>{t`connected_user`}</HLeftItemInnerText1Container1>
                      <HLeftItemInnerText2Container1>{`${userStore.user.given_name} ${userStore.user.nick_name ? '(' + userStore.user.nick_name + ')' : ''} ${userStore.user.family_name}`}</HLeftItemInnerText2Container1>
                      <HLeftItemInnerText3Container1>{t`mekome_admin`}</HLeftItemInnerText3Container1>       
                    </HLeftItemInnerTextContainer1>
                  </HLeftItemInnerContainer1Content>
                </HLeftItemInnerContainer1>
              </HLeftItemContainer1>
            </HLeftItem>
          </Header>
          <SearchBar>
            <SearchInput
              role='search'
              placeholder={t`search_placeholder`}
              variant="outlined"
              InputProps={{
                startAdornment: <Image src={Search} />,
              }}
              onChange={e => setSearch(e.target.value)}
            />
            <FilterButton
              active={filterActive || activeFilterCount > 0}
              onClick={() => setFilterActive(!filterActive)}
            >
              <FilterImageIcon active={filterActive || activeFilterCount > 0} src={FilterIcon} />
            </FilterButton>
            <AddButton onClick={() => { addUser() }} startIcon={<Add/>}>{t`add_contact`}</AddButton>
          </SearchBar>
        </Container>

        {filterActive && (
            <FilterContainer>
              <FilterTitleRow>
                <FilterTitle>{t`filter_by_tags`}</FilterTitle>
                <FilterModeToggle>
                  <FilterModeButton selected={filterMode === 'OR'} onClick={() => setFilterMode('OR')}>{t`filter_or`}</FilterModeButton>
                  <FilterModeButton selected={filterMode === 'AND'} onClick={() => setFilterMode('AND')}>{t`filter_and`}</FilterModeButton>
                </FilterModeToggle>
              </FilterTitleRow>

              {tagOptions.roles.length > 0 && (
                <FilterSectionContainer>
                  <FilterSectionLabel>{t`col_roles`}</FilterSectionLabel>
                  <FilterChipList>
                    {tagOptions.roles.map(name => (
                      <FilterChipButton
                        key={name}
                        roleradius
                        selected={selectedRoleTags.has(name)}
                        tagcolor={ROLE_TAG_STYLE.color}
                        tagborder={ROLE_TAG_STYLE.border}
                        tagbg={ROLE_TAG_STYLE.bg}
                        onClick={() => toggleFilterTag(setSelectedRoleTags, name)}
                      >{name}</FilterChipButton>
                    ))}
                  </FilterChipList>
                </FilterSectionContainer>
              )}

              {tagOptions.others.length > 0 && (
                <FilterSectionContainer>
                  <FilterSectionLabel>{t`col_tags`}</FilterSectionLabel>
                  <FilterChipList>
                    {tagOptions.others.map(name => {
                      const tc = getTagColor(name)
                      return (
                        <FilterChipButton
                          key={name}
                          selected={selectedOtherTags.has(name)}
                          tagcolor={tc.color}
                          tagborder={`${tc.border}40`}
                          tagbg={`${tc.color}10`}
                          onClick={() => toggleFilterTag(setSelectedOtherTags, name)}
                        >{name}</FilterChipButton>
                      )
                    })}
                  </FilterChipList>
                </FilterSectionContainer>
              )}

              {tagOptions.statuses.length > 0 && (
                <FilterSectionContainer>
                  <FilterSectionLabel>{t`filter_user_type`}</FilterSectionLabel>
                  <FilterChipList>
                    {tagOptions.statuses.map(name => (
                      <FilterChipButton
                        key={name}
                        selected={selectedStatusTags.has(name)}
                        tagcolor={STATUS_TAG_STYLE.color}
                        tagborder={STATUS_TAG_STYLE.border}
                        tagbg={STATUS_TAG_STYLE.bg}
                        onClick={() => toggleFilterTag(setSelectedStatusTags, name)}
                      >{name}</FilterChipButton>
                    ))}
                  </FilterChipList>
                </FilterSectionContainer>
              )}

              {activeFilterCount > 0 && (
                <FilterResetTitle onClick={resetFilters}>
                  <FilterImageIcon src={ZeroFilter} />&ensp;{t`filter_reset`}
                </FilterResetTitle>
              )}
            </FilterContainer>
        )}

        <ContactsTable>
          {selectedUserIds.size > 0 && !bulkDeleting && (
            <BulkActionsBar>
              <BulkActionsLeft>
                <BulkActionsText>{t('bulk_selected', { count: selectedUserIds.size, limit: BULK_DELETE_LIMIT })}</BulkActionsText>
                {filteredUsers.length > selectedUserIds.size && (
                  <SelectFirst50Link onClick={selectFirst50}>
                    {t('bulk_select_first', { limit: BULK_DELETE_LIMIT })}
                  </SelectFirst50Link>
                )}
              </BulkActionsLeft>
              <BulkDeleteButton onClick={handleBulkDelete} startIcon={<ActionsImage2 src={DeleteIcon} />}>
                {t`bulk_delete`}
              </BulkDeleteButton>
            </BulkActionsBar>
          )}
          {bulkDeleting && (
            <BulkProgressContainer>
              <BulkProgressBar>
                <BulkProgressFill pct={bulkProgress.total > 0 ? Math.round((bulkProgress.deleted / bulkProgress.total) * 100) : 0} />
              </BulkProgressBar>
              <BulkProgressLabel>
                {t('bulk_deleting', { done: bulkProgress.deleted, total: bulkProgress.total, percent: bulkProgress.total > 0 ? Math.round((bulkProgress.deleted / bulkProgress.total) * 100) : 0 })}
              </BulkProgressLabel>
            </BulkProgressContainer>
          )}
          {exporting && (
            <BulkProgressContainer>
              <BulkProgressBar>
                <BulkProgressFill pct={exportProgress.total > 0 ? Math.round((exportProgress.done / exportProgress.total) * 100) : 0} />
              </BulkProgressBar>
              <BulkProgressLabel>
                {t('bulk_exporting', { done: exportProgress.done, total: exportProgress.total, percent: exportProgress.total > 0 ? Math.round((exportProgress.done / exportProgress.total) * 100) : 0 })}
              </BulkProgressLabel>
            </BulkProgressContainer>
          )}
          <TableContainerStyled>
            <TableStyled stickyHeader>
                <TableHeadStyled>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={selectedUserIds.size > 0 && selectedUserIds.size < Math.min(filteredUsers.length, BULK_DELETE_LIMIT)}
                        checked={filteredUsers.length > 0 && selectedUserIds.size === Math.min(filteredUsers.length, BULK_DELETE_LIMIT)}
                        onChange={e => {
                          if (e.target.checked) setSelectedUserIds(new Set(filteredUsers.slice(0, BULK_DELETE_LIMIT).map(u => u.userId)))
                          else setSelectedUserIds(new Set())
                        }}
                        disabled={bulkDeleting}
                      />
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCellRight>{t`col_full_name`}</TableCellRight>
                    <TableCellRight>{t`col_nickname`}</TableCellRight>
                    <TableCellRight>{t`col_identity`}</TableCellRight>
                    <PhoneCell>{t`col_mobile`}</PhoneCell>
                    <TableCellRight>{t`col_email`}</TableCellRight>
                    <TableCellRight>{t`col_roles`}</TableCellRight>
                    <TableCellRight>{t`col_tags`}</TableCellRight>
                    <TableCellRight>{t`col_user_type`}</TableCellRight>
                    <TableCell>{t`col_actions`}</TableCell>
                  </TableRow>
                </TableHeadStyled>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        <Spinner />
                      </TableCell>
                    </TableRow>
                  )}

                  {!loading && filteredUsers.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={11} rowSpan={3} align="center">
                        {t`no_contacts`}
                      </TableCell>
                    </TableRow>
                  )}

                  {!loading &&
                    filteredUsers.map(user => (
                      <TableRow key={user.id} hover={true} onClick={() => !bulkDeleting && loadingUserId === null && getUser(user.userId)}>
                        <TableCell padding="checkbox" onClick={e => e.stopPropagation()}>
                          <Checkbox
                            checked={selectedUserIds.has(user.userId)}
                            onChange={() => toggleUser(user.userId)}
                            disabled={bulkDeleting}
                          />
                        </TableCell>
                        <TableCell align='right'>
                            {user.mekomeEnabled && <StyledMemberIcon src={MemberIcon} />}
                        </TableCell>
                        <TableCellRight>{user.fullName}</TableCellRight>
                        <TableCellRight>{user.nickname}</TableCellRight>
                        <TableCellRight>{user.israelId}</TableCellRight>
                        <PhoneCell>{user.mainMobilePhone?.replace(/^\+972(\d{2})(\d{7})/, '0$1-$2')}</PhoneCell>
                        <TableCellRight>{user.email}</TableCellRight>
                        <TableCellRight>
                          <TagChipsContainer>
                            {getTagNamesByType(user, 'role').map(name => (
                              <RoleTagChip key={name}>{name}</RoleTagChip>
                            ))}
                          </TagChipsContainer>
                        </TableCellRight>
                        <TableCellRight>
                          <TagChipsContainer>
                            {getTagNamesByType(user, 'others').map(name => {
                              const tc = getTagColor(name)
                              return <OtherTagChip key={name} tagcolor={tc.color} tagborder={tc.border}>{name}</OtherTagChip>
                            })}
                          </TagChipsContainer>
                        </TableCellRight>
                        <TableCellRight>
                          <TagChipsContainer>
                            {getTagNamesByType(user, 'status').map(name => (
                              <StatusTagChip key={name}>{name}</StatusTagChip>
                            ))}
                          </TagChipsContainer>
                        </TableCellRight>
                        <TableCell width={100}>
                          {loadingUserId === user.userId
                            ? <Spinner size={20} />
                            : <RowActions>
                                <StyledIconButton onClick={e => { e.stopPropagation(); editUser(user.userId) }}>
                                  <ActionsImage src={EditIcon2} />
                                </StyledIconButton>
                                <StyledIconButton onClick={e => { e.stopPropagation(); ConfirmContactRemoveAction(user.userId, user.fullName) }}>
                                  <ActionsImage src={DeleteIcon} />
                                </StyledIconButton>
                              </RowActions>
                          }
                        </TableCell>
                      </TableRow>
                  ))}
              </TableBody>
            </TableStyled>
</TableContainerStyled>
        </ContactsTable>   
    </Wrap>
  )
}


export default observer(PopulationManagement)

